import React, { PureComponent } from 'react'
import Head from "next/head";
import NProgress from "components/NProgress";
import SeoMeta from '/components/seoMeta';

export default class SubscribeUs extends PureComponent {
    render() {
        return (
            <div>
              <Head>
                <title>Subscribe Us</title>
              </Head>
              <SeoMeta 
                  url={`${process.env.BACKEND_URL}/subscribe-us`} 
                  type="article"
                  title='Subscribe-us'
                  description="Subscribe-us"
                  image='https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/duwun-news-logo.jpg'
                  section='Subscribe-us'
                  keywords='Subscribe-us'
                />        
              <NProgress />
            </div>
          );
    }
}
